import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button } from 'reactstrap';
import { updateUi } from '../../redux';
import { isEditionNavigationReadonlyPast } from '../../services/editionNavUi';

import './TktSyncButton.css';

const TktSyncButton = ({collapsed}) => {
    const { t }                                = useTranslation();
    const dispatch                             = useDispatch();
    const { showSynchronisationPanel }         = useSelector(state => state.ui);
    const { isTktsyncing, hasTktsyncingError } = useSelector(state => state.legacyScreenings);
    const is_readonly_edition                  = useSelector((state) => isEditionNavigationReadonlyPast(state));

    useEffect(() => {
        if (is_readonly_edition && showSynchronisationPanel) {
            dispatch(updateUi({ showSynchronisationPanel: false }));
        }
    }, [dispatch, is_readonly_edition, showSynchronisationPanel]);

    if (is_readonly_edition) {
        return null;
    }

    const togglePanel = () => {
        dispatch(updateUi({ showSynchronisationPanel: !showSynchronisationPanel }))
    }

    const color = hasTktsyncingError ? 'warning' : 'info';
    return (
        <Button
            onClick={togglePanel}
            color={color}
            className="TktSyncButton d-flex"
            title={t('events.sync_and_import')}
        >
            <i className={`fa ${isTktsyncing ? 'fa-spinner fa-spin' : 'fa-download'}`}></i>
            {!collapsed && <span className="truncate">&nbsp;{ t('events.sync_and_import') }</span>}
        </Button>
    );
}

export default TktSyncButton;
